// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"5ea17b6e","380":"03575968","453":"79ec2a8e","644":"3fda5cb5","687":"0c7ab132","711":"f5880201"}[chunkId] + ".chunk.js";
};